<template>
  <section class="invoice-preview-wrapper pt-4">
    <b-row class="invoice-preview">
      <b-col
        md="12"
        sm="12"
      >
        <documentacion
          :actualizardocs.sync="actualizardocs"
          :inmatricula="inmtrl"
          :inpersonafk="inpersonaId"
          @actualizardocs="actualizardocs=$event"
          @documentosCargados="loadedFiles=$event"
        />
        <br>
        <!-- Autoriza o Rechaza los elementos seleccionados -->
        <document-approval
          :files="loadedFiles"
          :user="inpersonaId"
          :loading="loader.loadingUploaded"
          @request-ended="() => loadArchivos()"
        />
      </b-col>
    </b-row>
  </section>
</template>

<script>
import {
  BRow, BCol,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { useRouter } from '@core/utils/utils'
import { rolesActions } from '@core/mixins/account-data/roles'
import DocumentApproval from '@/views/campus/components/document-approval/DocumentApproval.vue'
import { ref } from '@vue/composition-api'
import documentacion from '../Documentacion.vue'

export default {
  components: {
    documentacion,
    BRow,
    BCol,
    DocumentApproval,
  },
  directives: {
    Ripple,
  },
  mixins: [rolesActions],
  setup() {
    const { route } = useRouter()
    const inmtrl = (route.value.params.matricula) ? parseInt(route.value.params.matricula, 10) : 0
    const inpersonaId = (route.value.params.personafk) ? route.value.params.personafk : 0
    const loadedFiles = ref([])
    const loader = ref({ loadingUploaded: false, loadingPost: false })
    const actualizardocs = ref(false)
    const loadArchivos = () => {
      actualizardocs.value = true
    }

    return {
      // values
      inmtrl,
      inpersonaId,
      loadedFiles,
      loader,
      actualizardocs,
      loadArchivos,
    }
  },
}
</script>
